import React, { useEffect } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetSD";

import "./style/style.scss";
import "./style/animation.scss";
import { PlayerTriko } from "../../_partials/PlayerTrikoSD/Index";
import getContentById from "../../../../shared/utils/getContentById";

const getMainBackground = () => {
  return assets.background_1920;
};

export default function Index({ animation, data, mode, format, ...props }) {
  const { t } = useTranslation();

  const id = `sd_goal_alarm_${data?.id}`;
  const playerId = data?.playerId;
  const matchInfo = data?.matchInfo;

  const competitionId = matchInfo?.competition?.id;

  const scores = data?.scores;
  const scorer = data?.scorer;
  const teamSide = scorer?.side;
  const backgroundImage = require("../../../assets/wc/videos/goal_alarm.webm");

  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
        });

        animationReturn.timeline.play();
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  return (
    <div
      id={id}
      className={`T_sd_goal_alarm ${animation ? "animation" : ""} side-${teamSide}`}
    >
      <Backgrounds bg1={backgroundImage} loop={false} />

      <div className="wc-content wc-content-v2-alarm">
        <ProgressBar height="8px" />
        <div className="content">
          <div className="container">
            <div className={"left-block-side"}>
              <div className="left">
                <div className="main-header green-glow header-v1 alarm-goal-headline">{t('Goal', { keyPrefix: 'templates' })}!</div>
                <div className="main-header green-glow header-v2 alarm-goal-headline">{t('Goal', { keyPrefix: 'templates' })}!</div>
                <div className="main-header green-glow header-v3 alarm-goal-headline">{t('Goal', { keyPrefix: 'templates' })}!</div>
                <div className="triket-container">
                  <PlayerTriko
                    className={"goal-alarm"}
                    player={{
                      knownName: scorer?.name,
                      ...scorer,
                    }}
                    side={teamSide}
                    team={scorer?.team}
                    competitionId={competitionId}
                    isGoalAlarm
                  />
                </div>
              </div>
            </div>

            <div className={"right-block-side"}>
              <MatchScoreWidget
                homeTeam={homeTeam}
                awayTeam={awayTeam}
                matchInfo={matchInfo}
                isAlarm
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
